import React from 'react';
import { STUDIO } from '../../data/content';
import SectionHeader from '../SectionHeader';
import Callout from '../Callout';
import { useIntersection } from '../../hooks/useIntersection';

export default function Studio() {
  const { ref, visible } = useIntersection();
  return (
    <section id="studio" style={{ padding: '72px 0', borderBottom: '1px solid #D1D5DB' }}>
      <div className="r25-section-wrap" style={{ maxWidth: 'var(--max)', margin: '0 auto', padding: '0 40px' }}>
        <SectionHeader num={STUDIO.sectionNum} title={STUDIO.title} titleEm={STUDIO.titleEm} body={STUDIO.body} />
        <div ref={ref} className={`fade-in${visible ? ' visible' : ''}`}>
          <Callout title={STUDIO.pipelineCallout.title}>{STUDIO.pipelineCallout.body}</Callout>
          <Callout title={STUDIO.pricingCallout.title}>{STUDIO.pricingCallout.body}</Callout>
          <Callout title={STUDIO.revenueCallout.title}>{STUDIO.revenueCallout.body}</Callout>
        </div>
      </div>
    </section>
  );
}
